<template>
  <span>
  <mdb-carousel :interval="6000" showControls showIndicators >
    <template v-for="(el,indx) in featured_data" >
    <mdb-carousel-item img :src="CONTENT_DOMAIN+'/img/features/'+el['feature_1_image']"  alt="">
      
      <router-link  :to="'/content/'+el['id_cr']" v-bind:key>
        <mdb-carousel-caption :title="el['title']" v-html="el['teaser']" ></mdb-carousel-caption>
      </router-link>
      
      
    </mdb-carousel-item>
    <!--/img/features/feature_1_image/el['feature_1_image']-->
    
    </template>
    
    <mdb-carousel-item >
      <mdb-carousel-caption ></mdb-carousel-caption>
    </mdb-carousel-item>
    <mdb-carousel-item >
      <mdb-carousel-caption ></mdb-carousel-caption>
    </mdb-carousel-item>
    <mdb-carousel-item >
      <mdb-carousel-caption ></mdb-carousel-caption>
    </mdb-carousel-item>
    <mdb-carousel-item >
      <mdb-carousel-caption ></mdb-carousel-caption>
    </mdb-carousel-item>
    
    
  <!---->
    <!--<mdb-carousel-item img src="https://mdbootstrap.com/img/Photos/Slides/img%20(9).jpg" mask="black-slight" alt="Third slide">
      <mdb-carousel-caption title="Super light mask" text="Third text"></mdb-carousel-caption>
    </mdb-carousel-item>
    <mdb-carousel-item img src="https://mdbootstrap.com/img/Photos/Slides/img%20(9).jpg" mask="black-slight" alt="Third slide">
      <mdb-carousel-caption title="Super light mask" text="Third text"></mdb-carousel-caption>
    </mdb-carousel-item>
    <mdb-carousel-item img src="https://mdbootstrap.com/img/Photos/Slides/img%20(9).jpg" mask="black-slight" alt="Third slide">
      <mdb-carousel-caption title="Super light mask" text="Third text"></mdb-carousel-caption>
    </mdb-carousel-item>-->
  </mdb-carousel>
  </span>
</template>

<script>
  import {CONTENT_DOMAIN} from '@/constants/general_constants';
  import axios from 'axios';
  import { mdbCarousel, mdbCarouselItem, mdbCarouselCaption } from 'mdbvue';
  export default {
    name: 'CarouselFeatured',
    
    data() {
        return {
            featured_data: [],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };
        
    },
    /*data : {
        featured_data: []  
    },*/
    mounted :function(){
      
     /* this.$nextTick(() => this.showFeaturedData()),*/
        this.showFeaturedData()
        //this.showSlider=true
       
    },

    components: {
      mdbCarousel,
      mdbCarouselItem,
      mdbCarouselCaption
    },

    methods:{
      showFeaturedData(){ //console.log('yesy calling');
          axios.get(this.$store.state.apiUrl+'/featured_content',{
              params:{
                  id_language:this.$store.state.languageId,
                  id_country:this.$store.state.companyData['id_country'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company']
                  
              }
          })
          .then(response => {
              response = response.data
              //console.log(response);
              this.featured_data = response[0]
              /*this.$nextTick(function () {
                
              })*/
              
              //console.log(this.featured_data)
          })
          .catch(() => {
              this.featured_data = [];
          });
      }

    }


  }
</script>
<style scoped>
.carousel-item {
  height:auto;/*350px;*/
}

.carousel-caption{
  background-color: rgba(0, 0, 0, 0.45);
}
</style>
